import { render, staticRenderFns } from "./JessibucaDemo.vue?vue&type=template&id=24bd8850"
import script from "./JessibucaDemo.vue?vue&type=script&lang=js"
export * from "./JessibucaDemo.vue?vue&type=script&lang=js"
import style0 from "./JessibucaDemo.vue?vue&type=style&index=0&id=24bd8850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports